import { useQuery } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'

// The domains the viewer can view roles on. One cache entry serves the Roles list and every role page, so
// a role opened from the list renders straight away: there is no single-domain endpoint, a role page picks
// its domain out of this list, so one the viewer can't view reads as not found there too.
export function useViewableDomains() {
  const { iamService } = useServices()

  const { data, isLoading, errorMessage } = useQuery(['roles-viewable-domains'], iamService.getDomains, {})

  return { domains: data, isLoading, errorMessage }
}
